<template>
    <v-menu class="dot-menu" :close-on-content-click="false" v-model="openMenu" left offset-x nudge-top="100">
        <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" style="height: 36px !important;">
                <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
        </template>
        <v-list>
            
            <v-list-item link @click="clickDelete" v-if="item.agreement.is_uploaded_contract">
                <v-list-item-title><v-icon left>mdi-delete</v-icon>書類の削除</v-list-item-title>
            </v-list-item>
            
            <!-- 契約が対象で管理権限がある場合 -->
            <v-list-group
                    v-model="openList"
                    no-action
                    v-if="navi.plan == true"
                >
                <template v-slot:activator>
                    <v-list-item-title class="context-share"><v-icon left>mdi-share-variant</v-icon>キャビネット</v-list-item-title>
                </template>
                <v-list-item link @click="clickShare">
                    <v-list-item-title class="context-share"><v-icon left>mdi-plus</v-icon>共有登録</v-list-item-title>
                </v-list-item>
                <v-list-item link @click="clickDeleteShare">
                    <v-list-item-title class="context-delete"><v-icon left>mdi-minus</v-icon>共有削除</v-list-item-title>
                </v-list-item>  
            </v-list-group>
            
        </v-list>
    </v-menu>
</template>
<script>
export default {
    data() {
        return {
            loading: true,
            openList: false,
            openMenu: false,
            // 編集可否
            edit: false,
        }
    },
    props: {
        user: Object,
        navi: [],
        item: null,
    },
    methods: {
        clickDelete() {
            this.openMenu = false;
            this.$emit('clickDelete');
        },
        clickShare() {
            this.openMenu = false;
            this.$emit('clickShare');
        },
        clickDeleteShare() {
            this.openMenu = false;
            this.$emit('clickDeleteShare');
        },
    },
};
</script>

<style scoped>
    .context-delete {
        color: red;
    }
    .context-share {
        color: blue;
    }
    .context-menber-group,.context-loading {
        color: green;
    }
    .dot-menu {
        z-index: 100;
    }
</style>